let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("22n1a")).then(() => parcelRequire('kLWhg'));